export const formatInspection = (data) => {
  if (data === 'pending') return 'Aguardando vistoria';
  if (data === 'awaiting_complementar') return 'Aguardando vistoria complementar';
  if (data === 'started') return 'Vistoria iniciada';
  if (data === 'expired') return 'expired';
  if (data === 'canceled') return 'Cancelada';
  if (data === 'finished') return 'Vistoria finalizada';
  if (data === 'awaiting_report') return 'Aguardando relatório';
  if (data === 'activated') return 'Ativado';
};
